<template>
  <div>
    <b-alert :show="errors.any()" variant="danger" class="mb-2 py-2 px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <widget
      :type="widget.type"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :url="widget.url"
      :availability="widget.availability"
      :viewData="widget.viewData"
      :view="widget.view"
      @update:type="widget.type = $event"
      @update:title="widget.title = $event"
      @update:subtitle="widget.subtitle = $event"
      @update:url="widget.url = $event"
      @update:availability="widget.availability = $event"
      @update:viewData="widget.viewData = $event"
      @update:view="widget.view = $event"
    >

      <h6 class="mt-3 mb-2">{{$t('widgetAreas.items')}}:</h6>

      <b-list-group v-if="widget.items.length">
        <b-list-group-item v-for="item in widget.items" :key="item.id" variant="light" class="py-2 px-0">
          <b-row no-gutters>
            <b-col md="3" class="px-2 mb-2 mb-md-0">
              <b-input-group :prepend="$t('shared.icon')" size="sm">
                <b-input v-model="item.icon" dir="auto"/>
              </b-input-group>
            </b-col>

            <b-col md="4" class="px-2 mb-2 mb-md-0">
              <b-input-group :prepend="$t('shared.title')" size="sm">
                <b-input v-model="item.title" dir="auto"/>
              </b-input-group>
            </b-col>

            <b-col class="px-2 mb-2 mb-md-0">
              <b-input-group :prepend="$t('shared.url')" size="sm">
                <b-input v-model="item.url" dir="auto" placeholder="http(s)://"/>
              </b-input-group>
            </b-col>

            <b-col md="auto" class="px-2">
              <b-btn size="sm" variant="danger" @click="removeItem(item)">
                <font-awesome-icon icon="times" fixed-width class="align-middle"/>
              </b-btn>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>

      <b-btn size="sm" class="mt-2" variant="success" @click="addItem">
        <font-awesome-icon icon="plus" fixed-width class="align-middle"/>
      </b-btn>
    </widget>
  </div>
</template>

<script>
import EditorMixin from './EditorMixin'
import Widget from '../Widget'

export default {
  name: 'NavWidget',
  mixins: [EditorMixin],
  components: {
    Widget
  },
  methods: {
    addItem () {
      let item = {
        id: -String(Math.floor(Math.random() * 99999999)),
        title: null,
        icon: null,
        url: null
      }
      this.widget.items.push(item)
    },
    removeItem (item) {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.widget.items = this.widget.items.filter(l => l.id !== item.id)
      }
    }
  }
}
</script>
